
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoshirdicabs() {



    const cardData =
    {
        keyword: ' Pune to Shirdi Cab',
        heading: 'Prince Cabs: Pune to Shirdi Cab',
        headingDescription: 'Prince Cabs provides reliable Pune to Shirdi Cab services, perfect for Sai Baba temple visits, family travel, and pilgrimage tours. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride along the Pune–Ahmednagar–Shirdi route. With professional drivers, flexible schedules, and on-time pickups, we make your spiritual journey to Shirdi smooth and stress-free. Experience convenience, affordability, and trusted service with Prince Cabs’ dedicated cab service from Pune to Shirdi.',

        top: 'Top Places to Visit in Shirdi with Prince Cabs',

"topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Sai Baba Samadhi Mandir is the most sacred and visited place in Shirdi, housing the marble idol and tomb of Shri Sai Baba. Millions of devotees visit annually to seek blessings, making it one of India’s busiest pilgrimage centers. The temple exudes peace, with chants and prayers filling the atmosphere. The idol of Sai Baba, carved from Italian marble, radiates divine serenity. Daily rituals, aartis, and special festivals like Guru Purnima attract large gatherings. The temple complex is well-organized, ensuring a spiritual experience for visitors."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai is a historic mosque where Sai Baba spent a major part of his life, blessing devotees and performing miracles. It is considered the ‘heart of Shirdi,’ symbolizing unity between Hindu and Muslim traditions. The sacred dhuni (eternal fire) lit by Sai Baba still burns here, with its ash believed to have healing powers. The mosque also houses Baba’s stone seat and oil lamps he once lit. Devotees experience deep devotion and peace while visiting. Dwarkamai reflects Sai Baba’s message of harmony, faith, and compassion."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is another holy site in Shirdi, where Sai Baba used to rest on alternate nights during his later years. Today, it stands as a place of worship and remembrance. Every Thursday, a grand palki procession carries Baba’s portrait from Dwarkamai to Chavadi, retracing his steps. The small building preserves items used by Sai Baba, including a wooden bed and chair. Devotees gather here to feel a closer connection with Baba’s simple yet profound lifestyle. Its spiritual aura makes it a must-visit for pilgrims."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is an ancient shrine dedicated to Lord Khandoba, located at the entrance of Shirdi. It is historically significant as this was the place where Sai Baba was first recognized as a saint by villagers. The temple houses idols of Lord Khandoba along with other deities. Devotees often stop here before entering the main Sai Baba temple. The site marks the beginning of Sai Baba’s divine journey in Shirdi. Its historical and spiritual relevance makes it an important landmark for pilgrims."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a unique theme park and pilgrimage center that brings alive the life and teachings of Sai Baba. It showcases lifelike statues and scenes depicting important events from Baba’s life. Visitors can walk through recreated villages, temples, and shrines to understand Sai Baba’s simplicity and compassion. The serene gardens and exhibits make it both educational and devotional. Families enjoy the calm atmosphere and storytelling format. It is a great spot for devotees to connect with Baba’s legacy."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park is one of the biggest amusement parks in Shirdi, offering a refreshing break from spiritual tours. The park features thrilling water slides, wave pools, and rain dance zones. Families and children enjoy the wide variety of rides and entertainment options. It is well-maintained with food courts and resting areas. Located close to the temple complex, it’s a fun stop for those wanting relaxation after darshan. It adds a modern recreational touch to the holy town of Shirdi."
  },
  {
    "title": "Dixit Wada Museum",
    "description": "Located within the Sai Baba Temple complex, Dixit Wada Museum preserves rare photographs and personal belongings of Sai Baba. Items like Baba’s clothes, footwear, and utensils are displayed here. The museum offers devotees a glimpse into Baba’s simple lifestyle and compassionate teachings. Historical photographs narrate stories of his interaction with devotees. It is a quiet and soulful place for those who wish to know Baba more deeply. The museum adds historical depth to the spiritual journey in Shirdi."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a beautiful garden where Sai Baba used to spend time watering plants and meditating under a neem tree. The garden has a deep spiritual connection as it reflects Baba’s love for nature and simplicity. It contains a small shrine with a lamp that Baba himself lit, which continues to burn even today. Visitors enjoy the peaceful surroundings filled with greenery and flowers. The spot is ideal for meditation and reflection. It offers a calm retreat for devotees away from the crowded temple areas."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Located about 70 km from Shirdi, Shani Shingnapur is a world-famous temple dedicated to Lord Shani. The temple is unique as no idol is housed in a sanctum; instead, a black stone stands in the open air. The village is also famous for having houses without doors, as people believe Lord Shani protects them from theft. Pilgrims often combine Shirdi and Shani Shingnapur in their journey. The temple is especially crowded on Saturdays and during Shani Amavasya. It is a place of immense faith and devotion."
  },
  {
    "title": "Sai Tirth Theme Park",
    "description": "Sai Tirth is a modern 5D theme park in Shirdi that presents Sai Baba’s life through immersive shows and technology. It offers four major attractions, including 5D movies, laser shows, and exhibitions on Sai Baba’s teachings. The park blends spirituality with modern entertainment, making it popular among youth and families. Visitors gain a deeper understanding of Baba’s life in an interactive way. It is both devotional and engaging, adding variety to the Shirdi pilgrimage experience. Sai Tirth is a must-visit for tech-savvy devotees."
  }
],


"services": [
    {
        "name": "Pune to Shirdi Innova Crysta Taxi Fare",
        "description": "Travel in comfort and luxury with our Pune to Shirdi Innova Crysta taxi service. Get a clear and upfront fare estimate with no hidden charges. Ideal for family trips or small groups, the Crysta provides ample space, AC comfort, and a smooth ride throughout the journey."
    },
    {
        "name": "Pune to Shirdi Dzire Taxi Fare",
        "description": "Check affordable Swift Dzire taxi fares for your Pune to Shirdi trip. With budget-friendly pricing and comfortable seating, this cab is perfect for couples or small families seeking a safe, reliable, and economical ride to the temple town."
    },
    {
        "name": "Pune to Shirdi Etios Taxi Fare",
        "description": "Choose our Etios taxi for a peaceful ride from Pune to Shirdi at competitive fares. Spacious interiors, good mileage, and AC comfort make it an excellent option for spiritual trips with family or friends. Fare includes all standard charges, no surprises."
    },
    {
        "name": "Pune to Shirdi Cab",
        "description": "Book a cab from Pune to Shirdi for a hassle-free journey to the sacred Sai Baba temple. We offer a wide fleet of vehicles with professional drivers, comfortable seating, and punctual pickups to ensure a smooth, spiritual trip for you and your family."
    },
    {
        "name": "Pune to Shirdi Taxi",
        "description": "Reliable Pune to Shirdi taxi service available round-the-clock with easy booking and fixed pricing. Whether you’re visiting for a day or staying overnight, enjoy a clean cab, trained driver, and timely service throughout your journey."
    },
    {
        "name": "Pune to Shirdi Cab Charges",
        "description": "Get transparent and affordable cab charges for Pune to Shirdi trips. We provide all-inclusive pricing that covers tolls, driver allowance, and fuel. Choose from sedans, SUVs, or luxury cars as per your travel needs and budget."
    },
    {
        "name": "Pune to Shirdi Cab Package",
        "description": "Our Pune to Shirdi cab packages include round-trip travel, sightseeing options, and flexible return schedules. Best suited for family pilgrimages or weekend temple tours, with no hidden costs and complete driver support."
    },
    {
        "name": "Pune to Shirdi Cab Service",
        "description": "Top-rated cab service from Pune to Shirdi offering reliable, comfortable, and safe travel. With door-to-door pickup, well-maintained cars, and courteous drivers, we ensure a relaxed journey to one of Maharashtra’s most visited spiritual destinations."
    },
    {
        "name": "Pune Airport to Shirdi Cab",
        "description": "Pre-book a cab from Pune Airport to Shirdi for a seamless transfer experience. Our airport pickup includes real-time tracking, flight monitoring, and professional chauffeurs, ensuring you reach Shirdi comfortably and on time, even during odd hours."
    },
    {
        "name": "Pune Airport to Shirdi Taxi",
        "description": "Book an airport taxi from Pune to Shirdi with easy online booking and fixed fares. Ideal for outstation travelers landing in Pune, our service provides smooth transit to Shirdi with safe vehicles, AC comfort, and timely pickups from the terminal."
    },
    {
        "name": "Pune to Shirdi Taxi Drop",
        "description": "One-way taxi drop service from Pune to Shirdi for travelers who plan to stay longer or return by other means. Choose from a wide range of cars with experienced drivers and affordable rates for a single-side journey."
    },
    {
        "name": "Pune to Shirdi Innova Cab",
        "description": "Spacious and comfortable Innova cabs available for travel from Pune to Shirdi. Ideal for groups and families, these vehicles come with AC, ample boot space, and professional drivers for a safe and peaceful pilgrimage."
    },
    {
        "name": "Pune to Shirdi Round Trip Taxi",
        "description": "Plan a round-trip journey from Pune to Shirdi with flexible return timing and full-day availability. Our round-trip taxis are perfect for devotees who want a same-day return or wish to explore nearby places along the route."
    },
    {
        "name": "Pune to Shirdi Family Cab",
        "description": "Book a comfortable family cab for your Pune to Shirdi trip with large seating capacity, extra luggage space, and smooth rides. Perfect for spiritual journeys, our cabs ensure safety and convenience for every age group."
    },
    {
        "name": "Pune to Shirdi Affordable Taxi",
        "description": "Travel from Pune to Shirdi without overspending with our affordable taxi options. Clean vehicles, budget pricing, and trusted drivers make this service a favorite for students, solo travelers, and small families."
    }
],
"tableData": [
    ["Pune to Shirdi Innova Crysta Taxi Fare", "Pune to Shirdi Dzire Taxi Fare"],
    ["Pune to Shirdi Etios Taxi Fare", "Pune to Shirdi Cab"],
    ["Pune to Shirdi Taxi", "Pune to Shirdi Cab Charges"],
    ["Pune to Shirdi Cab Package", "Pune to Shirdi Cab Service"],
    ["Pune Airport to Shirdi Cab", "Pune Airport to Shirdi Taxi"],
    ["Pune to Shirdi Taxi Drop", "Pune to Shirdi Innova Cab"],
    ["Pune to Shirdi Round Trip Taxi", "Pune to Shirdi Family Cab"],
    ["Pune to Shirdi Affordable Taxi", ""]
],


 "whychoose": [
    {
        "WhyChooseheading": "Trusted Pune to Shirdi Cab Service",
        "WhyChoosedescription": "Prince Cabs provides reliable cab services from Pune to Shirdi, ideal for spiritual trips, family visits, or group pilgrimages. We ensure timely pickups and a peaceful ride to Sai Baba's temple town."
    },
    {
        "WhyChooseheading": "Comfortable and Pilgrimage-Friendly Vehicles",
        "WhyChoosedescription": "Our fleet includes clean, air-conditioned, and spacious cabs designed for long journeys. Travel in comfort with ample seating and space for luggage and offerings."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Safe Journey",
        "WhyChoosedescription": "Our courteous drivers are well-versed with the Pune to Shirdi route, ensuring safe driving, smooth navigation, and timely halts for meals or breaks as per your convenience."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Your Darshan Plans",
        "WhyChoosedescription": "We offer one-way, same-day return, and multi-day trip options to suit your schedule. Book your Pune to Shirdi cab easily through call, website, or WhatsApp with quick confirmation."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Cabs for a Safe Trip",
        "WhyChoosedescription": "Every cab is sanitized before and after each journey. We follow strict hygiene practices and ensure regular vehicle maintenance for your safety and peace of mind."
    },
    {
        "WhyChooseheading": "Clear Pricing with No Hidden Costs",
        "WhyChoosedescription": "Enjoy transparent and competitive pricing with no surprise charges. Choose from multiple payment options including UPI, debit/credit cards, net banking, and cash."
    },
    {
        "WhyChooseheading": "Round-the-Clock Customer Support",
        "WhyChoosedescription": "Our dedicated support team is available 24/7 to assist with your booking, travel updates, or any issues during your Pune to Shirdi trip. We’re here to ensure a smooth and satisfying journey."
    }
]



















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Shirdi cab services?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable cab services from Pune to Shirdi, ideal for pilgrimages, family trips, and spiritual journeys.',
    },
    {
        question: 'What types of cabs are available for the Pune to Shirdi route?',
        answer: 'We provide a wide selection of cabs including hatchbacks, sedans, SUVs, and tempo travellers to suit different budgets and group sizes.',
    },
    {
        question: 'Are the cabs suitable for long-distance travel like Pune to Shirdi?',
        answer: 'Absolutely! Our cabs are well-maintained, air-conditioned, and driven by experienced chauffeurs to ensure a safe and comfortable journey.',
    },
    {
        question: 'Can I customize my trip with stopovers on the way to Shirdi?',
        answer: 'Yes, you can fully customize your itinerary with preferred stops, pickups, and drop-offs. We aim to make your travel as flexible and convenient as possible.',
    },
    {
        question: 'What is the cost of a cab from Pune to Shirdi?',
        answer: 'The fare depends on the type of vehicle, travel duration, and any special requirements. Contact Prince Cabs for a personalized and affordable quote.',
    },
    {
        question: 'How do I book a Pune to Shirdi cab with Prince Cabs?',
        answer: 'Booking is simple—just reach out to us via our website or phone with your travel details. Our team will help you choose the right cab for your trip.',
    },
    {
        question: 'Are your cabs clean and safe for religious trips like Shirdi?',
        answer: 'Yes, all our vehicles are regularly sanitized, serviced, and maintained to ensure a clean, safe, and pleasant journey to Shirdi.',
    },
];

const testimonials = [
    {
        name: "Mr. Anil Joshi",
        position: "Devotee",
        text: "Prince Cabs made our Pune to Shirdi pilgrimage peaceful and stress-free. The cab was clean and the driver was very cooperative.",
        image: "/img/testimonial/testimonial-thumb-shirdi-1.png",
    },
    {
        name: "Mrs. Meenal Desai",
        position: "Senior Citizen Traveler",
        text: "I traveled to Shirdi from Pune with Prince Cabs. The service was punctual, the cab was comfortable, and the driver was respectful throughout.",
        image: "/img/testimonial/testimonial-thumb-shirdi-2.png",
    },
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cab",
  "image": "https://princecab.com/assets/images/pune-shirdi-cab.jpg",
  "description": "Book Pune to Shirdi cab with Prince Cabs – Comfortable, safe, and affordable options including Dzire, Etios, Innova Crysta, and family SUVs. Ideal for pilgrimages, airport pickups, and round trip bookings. Available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "7015"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-shirdi-cab"
  }
};



    return (
        <div>

<Helmet>
  <title>Pune to Shirdi Cab | Comfortable & Affordable Pilgrimage Taxi | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs provides Pune to Shirdi cab service with reliable vehicles like Dzire, Etios, and Innova Crysta. Affordable fares, airport pickups, and round trip cabs for Shirdi temple visits. 24/7 booking online."
  />
  <meta
    name="keywords"
    content="Pune to Shirdi Innova Crysta Taxi Fare, Pune to Shirdi Dzire Taxi Fare, Pune to Shirdi Etios Taxi Fare, Pune to Shirdi Cab, Pune to Shirdi Taxi, Pune to Shirdi Cab Charges, Pune to Shirdi Cab Package, Pune to Shirdi Cab Service, Pune Airport to Shirdi Cab, Pune Airport to Shirdi Taxi, Pune to Shirdi Taxi Drop, Pune to Shirdi Innova Cab, Pune to Shirdi Round Trip Taxi, Pune to Shirdi Family Cab, Pune to Shirdi Affordable Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdicabs;